import React, { useEffect, useState, useRef } from "react"
import BarocdeReaderHoneywell from "../../../pages/utils/honeywell/BarcodeReader"
import { Button, TextField } from "@mui/material"
import ModalCameraQr from "../../../components/Obturador/ModalCameraQr"
import { styled } from "@mui/material/styles"
import ObturaradorIcon from "../../../assets/iconos/Obturador.ico"
import { Html5QrcodeScanner } from "html5-qrcode"
const StyledButtonsFiltro = styled(Button)(({ theme }) => ({
  margin: "auto",
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
}))

const Obturador = ({ scannerParams, executeFunction, shouldHideButton, onTextFieldChange }) => {
  const [infoRead, setInfoRead] = useState({
    barcodeDataText: "",
    symbTypeText: "",
    readTimeText: "",
  })
  const [isOpenModalQr, setIsOpenModalQr] = useState(false)
  const [isHoneywellDetected, setIsHoneywellDetected] = useState(false)
  const targetInputRef = useRef(null)
  const qrScannerRef = useRef(null)
  const myBarcodeReaderHW = useRef(null) // Use ref to store Honeywell reader instance
  const [inputValue, setInputValue] = useState("")

  // Actualiza el valor en el componente principal cuando el TextField cambia
  const handleTextFieldChange = (event) => {
    const newValue = event.target.value
    setInputValue(newValue)
    onTextFieldChange(newValue) // Llama a la función pasada desde el componente principal
  }

  // Detect Honeywell API
  useEffect(() => {
    const initializeHoneywell = async () => {
      if (window.BarcodeReaders) {
        const readers = new window.BarcodeReaders()
        const result = await readers.getAvailableBarcodeReaders()
        if (result && result.length > 0) {
          setIsHoneywellDetected(true)
          myBarcodeReaderHW.current = new BarocdeReaderHoneywell(setInfoRead)
          myBarcodeReaderHW.current.setup() // Setup Honeywell only if a scanner is detected
        } else {
          setIsHoneywellDetected(false)
        }
      }
    }
    initializeHoneywell()
  }, [])

  // Initialize html5-qrcode if Honeywell is not available
  useEffect(() => {
    if (!isHoneywellDetected && qrScannerRef.current) {
      qrScannerRef.current = new Html5QrcodeScanner("qr-reader", { fps: 10, qrbox: { width: 250, height: 250 } }, false)
      qrScannerRef.current.render(onScanSuccess, onScanFailure)
    }
    return () => {
      if (qrScannerRef.current) {
        qrScannerRef.current.clear().catch((error) => console.error("Failed to clear html5-qrcode scanner.", error))
      }
    }
  }, [isHoneywellDetected])

  // Callbacks for html5-qrcode
  const onScanSuccess = (decodedText) => {
    setInfoRead({
      barcodeDataText: decodedText,
      symbTypeText: "QR Code",
      readTimeText: new Date().toISOString(),
    })
  }

  const onScanFailure = (error) => {
    console.warn(`Scan error = ${error}`)
  }

  // Handle key press for scanner
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && document.activeElement === targetInputRef.current) {
        if (isHoneywellDetected) {
          openMyBarcodeReaderHW() // Trigger Honeywell scanner on Enter
        } else {
          handleOpenHtml5Qrcode() // Trigger html5-qrcode scanner
        }
      }
    }

    window.addEventListener("keydown", handleKeyDown)
    return () => {
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [isHoneywellDetected])

  // Open Honeywell barcode reader
  const openMyBarcodeReaderHW = () => {
    if (isHoneywellDetected && myBarcodeReaderHW.current) {
      myBarcodeReaderHW.current.openReader()
    }
  }

  // Open html5-qrcode scanner
  const handleOpenHtml5Qrcode = () => {
    setIsOpenModalQr(true)
  }

  // Modal handling
  const cleanTextScanner = () => {
    setInfoRead({
      barcodeDataText: "",
      symbTypeText: "",
      readTimeText: "",
    })
  }

  const handleOpenModalQr = () => {
    cleanTextScanner()
    setIsOpenModalQr(true)
  }

  const handleCloseModalQr = () => {
    setIsOpenModalQr(false)
  }

  return (
    <div>
      {/* Text field with specific ID and ref */}
      <TextField
        id="targetInput"
        label="Enter ID to scan"
        variant="outlined"
        inputRef={targetInputRef}
        onChange={handleTextFieldChange}
      />
      {!shouldHideButton && (
        <Button
          variant="outlined"
          onClick={() => {
            handleOpenModalQr()
            if (isHoneywellDetected) {
              openMyBarcodeReaderHW()
            } else {
              handleOpenHtml5Qrcode()
            }
          }}
          color="secondary"
          className={StyledButtonsFiltro}
          sx={{
            width: "250px",
          }}
          endIcon={<img src={ObturaradorIcon} style={{ width: "22px" }} alt="buscar" />}
        >
          Abrir obturador
        </Button>
      )}

      {/* Conditional html5-qrcode scanner */}
      {!isHoneywellDetected && <div id="qr-reader" style={{ display: isOpenModalQr ? "block" : "none" }}></div>}

      <ModalCameraQr
        isOpenModalQr={isOpenModalQr}
        handleCloseModalQr={handleCloseModalQr}
        scannerParams={scannerParams}
        infoRead={infoRead}
        setInfoRead={setInfoRead}
      />
    </div>
  )
}

export default Obturador
